export type { BonusReportAtEventTranslations } from "./bonus-report-at-event-pt-br";
export { BONUS_REPORT_AT_EVENT_PT_BR } from "./bonus-report-at-event-pt-br";
export { BONUS_REPORT_AT_EVENT_EN_US } from "./bonus-report-at-event-en-us";
export { BONUS_REPORT_AT_EVENT_ES_MX } from "./bonus-report-at-event-es-mx";
export { BONUS_REPORT_AT_EVENT_FR_FR } from "./bonus-report-at-event-fr-fr";
